<template>
  <section v-if="componentReady" class="container-wrapper thank-you-page">
    <h1 class="thank-you-page__title">
      {{ title }}
    </h1>
    <div class="thank-you-page__text p" v-html="text" />
    <div class="thank-you-page__button-wrapper">
      <BaseButton
        class="thank-you-page__button"
        @click="navigateHome"
      >
        {{ buttonText }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
  // Step 6
  import { mapGetters, mapActions } from 'vuex'
  import { DEFAULT_LANG } from '@/helpers/constant'

  export default {
    name: 'ThankYouPage',
    data () {
      return {
        title: '',
        text: '',
        buttonText: '',
        componentReady: false
      }
    },
    computed: {
      ...mapGetters([
        'getAliasParamCity',
        'getAliasParamDealer'
      ])
    },
    async created () {
      const { title, text, buttonText } = await this.fetchThankYouPageData()
      this.title = title
      this.text = text
      this.buttonText = buttonText

      this.componentReady = true
    },
    methods: {
      ...mapActions(['fetchThankYouPageData']),
      navigateHome () {
        let currentRoute = '/'
        const lang = this.$store.state.currentLang
        const queryLang = lang !== DEFAULT_LANG ? `&lang=${lang}` : ''

        if (this.getAliasParamCity || this.getAliasParamDealer) {
          currentRoute = `/?city=${this.getAliasParamCity}&dealer=${this.getAliasParamDealer}${queryLang}`
        }
        this.$router.push(currentRoute)
      }
    }
  }
</script>

<style lang="scss">
  .thank-you-page {
    max-width: 495px;

    @include mobile {
      max-width: 290px;
    }

    &__text {
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      text-align: center;
    }

    &__button {
      &-wrapper {
        display: flex;
        justify-content: center;
      }

      margin-top: 50px;

      @include mobile {
        margin-top: 25px;
      }
    }
  }
</style>
